export default "__VITE_ASSET__xwilyOzb__"